/* eslint-disable */
import { BehaviorSubject, Subject } from "rxjs";
import { ChangeDetectorRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { Field } from "./vforms-model";

export abstract class BaseFieldEditorComponent {
    protected _unsubscribeAll: Subject<any> = new Subject<any>();

    public onValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    field: Field;

    public form: FormGroup;

    protected constructor(protected _changeDetector: ChangeDetectorRef) {}

    onInit() {
        this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            this.field.update(value);
            this.onValid.next(this.form.valid);
            this._changeDetector.detectChanges();
        });
        this.onValid.next(this.form.valid);
        this._changeDetector.detectChanges();
    }
}
